import React from 'react';

function UserGraphIcon({ color = '#BDBEBF' }) {
  return (
    <svg
      height="21.253"
      style={{ display: 'block' }}
      viewBox="0 0 30.057 21.253"
      width="30.057"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(.462 .086)">
        <g
          data-name="Groupe 1834"
          fill="none"
          stroke={color}
          strokeMiterlimit="10"
          strokeWidth="1.2"
          transform="translate(.138 .514)"
        >
          <path
            d="M28.784 20.057a15.671 15.671 0 00-1.859-6.048 5.516 5.516 0 00-1.853-1.859c-1.855-1.137-7.873-.993-9.684 0a6.27 6.27 0 00-2.644 3.52 24.9 24.9 0 00-1.067 4.387zm-5.187-14.2a3.339 3.339 0 11-3.338-3.262 3.3 3.3 0 013.338 3.262z"
            data-name="Tracé 268"
          />
          <path d="M0 4.633L0 0" data-name="Ligne 296" transform="translate(17.177 15.549)" />
          <path d="M0 4.633L0 0" data-name="Ligne 297" transform="translate(23.597 15.549)" />
          <path
            d="M14.689 12.511V1.037A1.047 1.047 0 0013.627 0h-2.779a1.047 1.047 0 00-1.059 1.037v19.016h2.89"
            data-name="Tracé 269"
          />
          <path
            d="M4.895 20.053h4.9V7.199a1.221 1.221 0 00-1.221-1.221H6.116a1.221 1.221 0 00-1.221 1.221z"
            data-name="Tracé 270"
          />
          <path
            d="M0 20.054h4.895v-7.065a1.226 1.226 0 00-1.227-1.227H1.226A1.226 1.226 0 000 12.989z"
            data-name="Tracé 271"
          />
        </g>
      </g>
    </svg>
  );
}

export default UserGraphIcon;
